import Rest from '../Rest'

/**
 * Planos de cobrança da plataforma (taxa de serviço) — admin-only.
 */
export default class FeePlanService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/fee_plans'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getVersions(planId: number) {
    return this.get(`/${planId}/versions`)
  }

  saveVersion(planId: number, data: any) {
    return this.post(`/${planId}/versions`, data)
  }

  simulate(data: any) {
    return this.post('/simulate', data)
  }

  assign(planId: number, data: any) {
    return this.post(`/${planId}/assignments`, data)
  }
}
